import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const LoginPage = lazy(() =>
  import("@/admin/pages/LoginPage").then((m) => ({ default: m.LoginPage })),
);

export const Route = createFileRoute("/admin_/login")({
  head: () => ({
    meta: [
      { title: "Connexion · 2AM Hospitality" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => (
    <Suspense fallback={null}>
      <LoginPage />
    </Suspense>
  ),
});
